import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JhiAlertService } from 'ng-jhipster';

import { IPackingTypeMySuffix } from 'src/app/shared/model/packing-type-my-suffix.model';
import { PackingTypeMySuffixService } from './packing-type-my-suffix.service';
import { ILoadingTypeMySuffix } from 'src/app/shared/model/loading-type-my-suffix.model';
import { LoadingTypeMySuffixService } from 'src/app/entities/loading-type-my-suffix';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { IMyOptions, IMyDateModel } from 'mydatepicker';
import { Principal } from 'src/app/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ConfirmationModalComponent } from 'src/app/shared/confirmation-modal/confirmation-modal.component';
import { ConfirmationModelService } from 'src/app/shared/confirmation-modal/confirmation-model.service';
import { FutureDataType } from 'src/app/shared/model/future_data_type.model';
import { CommonUtils } from 'src/app/shared/util/common-utils';

@Component({
    selector: 'jhi-packing-type-my-suffix-update',
    templateUrl: './packing-type-my-suffix-update.component.html'
})
export class PackingTypeMySuffixUpdateComponent implements OnInit {
    private _packingType: IPackingTypeMySuffix;
    isSaving: boolean;

    loadingtypes: ILoadingTypeMySuffix[];
    // effective date
    date: Date = new Date();
    resetDateModel = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: (this.date.getDate() - 1) }
    effectivepDatePickerOptions: IMyOptions = {
        dateFormat: 'dd/mm/yyyy',
        disableUntil: this.resetDateModel
    };
    fromEffeciveDate: any;
    dateModel = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate()
    }
    constructor(
        private jhiAlertService: JhiAlertService,
        private packingTypeService: PackingTypeMySuffixService,
        private loadingTypeService: LoadingTypeMySuffixService,
        private activatedRoute: ActivatedRoute,
        private languageChangeService: LanguageChangeService,
        private principal: Principal,
        private modalService: BsModalService,
        private confirmationModelService: ConfirmationModelService,
    ) {
                this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
     }

    ngOnInit() {
        this.effectivepDatePickerOptions.disableUntil = this.principal.dateFormateServerToClientMin(this.date);
        this.isSaving = false;
        this.activatedRoute.data.subscribe(({ packingType }) => {
            this.packingType = packingType;
        });
        // this.loadingTypeService.query().subscribe(
        //     (res: HttpResponse<ILoadingTypeMySuffix[]>) => {
        //         this.loadingtypes = res.body;
        //     },
        //     (res: HttpErrorResponse) => this.onError(res.message)
        // );
        this.fromEffeciveDate = { date: this.dateModel };
    }

    previousState() {
        window.history.back();
    }

    save() {
        // Sent string to backed from date object 
        let incDate = this.principal.dateFormateClientToServer(this.fromEffeciveDate.date);
        this.packingType.fromEffectiveDate = incDate;
        this.openConfirmationModalForFutureRecordDeletion();
    }

    saveOrUpdate() {
        this.isSaving = true;
        // if (this.packingType.id !== undefined) {
        if (CommonUtils.isNotNil(this.packingType.id)) {
            this.subscribeToSaveResponse(this.packingTypeService.update(this.packingType));
        } else {
            this.subscribeToSaveResponse(this.packingTypeService.create(this.packingType));
        }
    }

    private subscribeToSaveResponse(result: Observable<HttpResponse<IPackingTypeMySuffix>>) {
        result.subscribe((res: HttpResponse<IPackingTypeMySuffix>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.onSaveError());
    }

    private onSaveSuccess() {
        this.isSaving = false;
        this.deleteExistedFutureRecordDetails();
        this.previousState();
    }

    private onSaveError() {
        this.isSaving = false;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    trackLoadingTypeById(index: number, item: ILoadingTypeMySuffix) {
        return item.id;
    }

    getSelected(selectedVals: Array<any>, option: any) {
        if (selectedVals) {
            // for (let i = 0; i < selectedVals.length; i++) {
            //     if (option.id === selectedVals[i].id) {
            //         return selectedVals[i];
            //     }
            // }
            for (let _selectedVal of selectedVals) {
                if (option.id === _selectedVal.id) {
                    return _selectedVal;
                }
            }
        }
        return option;
    }
    get packingType() {
        return this._packingType;
    }

    set packingType(packingType: IPackingTypeMySuffix) {
        this._packingType = packingType;
    }

    trimName(event) {
        if (this.packingType.name) {
            this.packingType.name = this.packingType.name.trim();
        }
    }
    trimPackingTypeName(event) {
        this.packingType.name = this.packingType.name.trim();
    }

    onDateChanged(event: IMyDateModel) {
        let selectedFromEffectiveDate = this.principal.dateFormateClientToServer(event.date)
        console.log('onDateChanged(): ', selectedFromEffectiveDate);
        // if (this.packingType.id !== null && this.packingType.id !== undefined) {
        if (CommonUtils.isNotNil(this.packingType.id)) {
            this.packingTypeService.findByIdAndFromEffectiveDate(this.packingType.id, selectedFromEffectiveDate).subscribe(response => {
                console.log(response);
                if (CommonUtils.isNotNil(response.body) && response.body['isSuccess']) {
                    this.packingType = response.body['payLoad'];
                }
            });
        }
    }

    // global modal open and close event
    bsModalRef: BsModalRef;

    isConfirmDeletion = false;
    /* this is how we open a Modal Component from another component */
    openConfirmationModalForFutureRecordDeletion() {
        this.isConfirmDeletion = false;
        // if (this.packingType.id !== null && this.packingType.id !== undefined) {
        if (CommonUtils.isNotNil(this.packingType.id)) {
            let form_data = {
                masterId: this.packingType.id,
                futureDataType: FutureDataType.PACKING_TYPE.valueOf(),
                fromEffectiveDateFormatted: this.packingType.fromEffectiveDate
            }
            this.confirmationModelService.findFutureRecordExisted(form_data).subscribe(response => {
                const resBody = response.body;
                if (resBody.isSuccess) {
                    const initialState = {
                        title: 'Packing Type (' + this.packingType.name + ')',
                        message: resBody.message,
                    };
                    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, { initialState, class: "modal-lg" });
                    this.bsModalRef.content.onClose.subscribe(result => {
                        if (result) {
                            this.isConfirmDeletion = true;
                            this.saveOrUpdate();
                        }
                    });
                } else {
                    this.saveOrUpdate();
                }
            });

        } else {
            this.saveOrUpdate();
        }
    }


    deleteExistedFutureRecordDetails() {
        if (this.isConfirmDeletion) {
            let form_data = {
                masterId: this.packingType.id,
                futureDataType: FutureDataType.PACKING_TYPE.valueOf(),
                fromEffectiveDateFormatted: this.packingType.fromEffectiveDate
            }
            this.confirmationModelService.deleteExistedFutureRecord(form_data).subscribe(response => {
                console.log(response);
                this.isConfirmDeletion = false;
            });
        }
    }
}
